import React, { Component } from 'react'

import '../../css/BisharatMain.css';
import profileImg from '../../data/images/profileImg.jpg';
import AuthService from "../../services/AuthService";
import translate from '../../languages/translate';
import PartnerService from '../../services/PartnerService';
export default class PartnerDetail extends Component {
    state = {
        onePartner: [],
        haveRoleOfAdminOrMod: false
    }

    componentDidMount() {
        const { match: { params } } = this.props;
        const partnerId = params.id;
        PartnerService.getPartner(partnerId)
            .then(res => {
                const onePartner = res.data;
                this.setState({ onePartner });
            })
        const whatRole = AuthService.getUserRole();
        if (whatRole === ('MODERATOR') || whatRole === ('ADMIN')) {
            this.setState({ haveRoleOfAdminOrMod: true });
        }
    }


    goToFamilyTree(id) {
        window.open(`/family-tree/${id}`, '_blank');
    }


    gotoPartnerEdit(id) {
        window.location.href = `/family-partners/${id}/edit`;
    }

    gotoAddChild(id) {
        window.location.href =  `/family-members/${id}/childcreate`;
    }

    gotoUpalodProfilePicture(id) {
                   window.location.href = `/family-members/profile/${id}`;
    }

    showPartner(id) {
        window.location.href = `/family-members/${id}`;
}
   


    render() {

        return (
            <div className="top-level-page-main member-detail">
                <div className="view-details member-detail ">
                    <div className="card-details">

                        <div className="prfile-signed">
                           
                                <img
                                    src={profileImg}
                                    alt="profile-img"
                                />
                            
                        </div>


                        <div className="card-group-field">
                            <h4>  {translate("name")}   </h4>
                            <h4> {this.state.onePartner.name}   </h4>
                        </div>
                        <div className="card-group-field">
                            <h4>    {translate("father-name")}   </h4>
                            <h4> {this.state.onePartner.fatherName ? this.state.onePartner.fatherName : <p>{translate("notfound")}</p>}   </h4>
                        </div>
                        <div className="card-group-field">
                            <h4>   {translate("mother-name")}    </h4>
                            <h4> {this.state.onePartner.motherName ? this.state.onePartner.motherName : <p>{translate("notfound")}</p>}   </h4>
                        </div>
                        <div className="card-group-field">
                            <h4>   {translate("family-name")}    </h4>
                            <h4> {this.state.onePartner.familyName ? this.state.onePartner.familyName : <p>{translate("notfound")}</p>}   </h4>
                        </div>
                     

                     
                        <div className="card-group-field">
                            <h4>  {translate("gender")}  </h4>
                            <h4> {this.state.onePartner.gender === 'male' ? translate("male") : translate("female") } </h4>
                        </div>
                    
                        <div className="card-group-field">
                            <h4>  {translate("birthdate")} </h4>
                            <h4> {(this.state.onePartner.birthdate) ? this.state.onePartner.birthdate : <p>{translate("notfound")}</p>}   </h4>
                        </div>
                     




                        {this.state.haveRoleOfAdminOrMod && <>


                            <div className="card-group-field">
                                <h4> ID </h4>
                                <h4> {this.state.onePartner.id ?  this.state.onePartner.id : <p>{translate("notfound")}</p>}</h4>
                            </div>

                            <div className="card-group-field">
                                <h4> {translate("phone-num")} </h4>
                                <h4> {this.state.onePartner.phoneNumber ? this.state.onePartner.phoneNumber : <p>{translate("notfound")} </p>}   </h4>
                            </div>

                        

                    
                        </>
                        }


                        {/* <button className="btn" onClick={() => this.goToFamilyTree(this.state.oneMember.id)}>{translate("fa-tree-person")}  </button> */}
                        {this.state.haveRoleOfAdminOrMod ?
                        <>
                            <button className="btn" onClick={() => this.gotoPartnerEdit(this.state.onePartner.id)}>{translate("edit")}</button>
                            {/* <button className="btn" onClick={() => this.gotoAddChild(this.state.oneMember.id)}>{translate("add-child")}</button> */}
                            {/* <button className="btn" onClick={() => this.gotoUpalodProfilePicture(this.state.oneMember.id)}>{translate("profile-pic")}  </button> */}
                           
                            </>
                            : <></>
                        }

                        <button className="btn" onClick={this.props.history.goBack}>  {translate("back")}  </button>
                    </div>
                </div>
            </div>
        )
    }
}
